import React from 'react';
import { connect } from 'react-redux';
import { find, get } from 'lodash';
import LikelyShare from '../../components/commit-form/likely-share';
import LikelyShareWithDeposit from '../../components/commit-form/likely-share.with-deposit';
import { Money } from '../../lib/money';
import { FIXED_PER_PERSON } from '../../lib/split-types';
import { getCurrentPurchase } from '../../selectors/purchase-selector';
import { COMMIT_NAMESPACE } from '../../actions';

const LikelyShareContainer = (props) => {
  if (props.deposit) return withDeposit(props);

  return (
    <LikelyShare
      claimedSlots={props.claimedSlots}
      amount={props.amount}
      shareAmount={props.shareAmount}
      feesAmount={props.feesAmount}
      slotName={props.slotName}
    />
  );
};

const withDeposit = (props) => {
  return (
    <LikelyShareWithDeposit
      amount={props.amount}
      depositAmount={props.depositAmount}
    />
  );
};

const mapStateToProps = ({ memberships, purchases, projections }) => {
  const membership = get(projections, `${COMMIT_NAMESPACE}.memberships.${memberships.current}`);
  const projectedPurchase = get(projections, `${COMMIT_NAMESPACE}.purchase`);
  const currentPurchase = getCurrentPurchase({ purchases });

  if (!projectedPurchase || !currentPurchase || !membership) return {};

  const deposit = find(projectedPurchase.payments, payment => payment.number === 1);
  const { group: { splitType } } = currentPurchase;
  return {
    amount: membership.amount,
    claimedSlots: membership.claimedSlots,
    costPerSlot: splitType === FIXED_PER_PERSON ? projectedPurchase.currentProductCostAmount : null,
    depositAmount: deposit ? deposit.amount : Money.zero(currentPurchase.currencyCode),
    shareAmount: membership.shareAmount,
    feesAmount: membership.fees.consumerFee,
    slotName: currentPurchase.slotName,
  };
};


export default connect(mapStateToProps)(LikelyShareContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/commit-form/likely-share.container.js